export default __webpack_public_path__ + "static/dge_small-image_4-517ae82f96ef32d5af5dcb98a9b29095.webp";